<template>
    <select
        :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value)"
        :disabled="disabled"
        :class="disabled ? 'bg-gray-100' : ''"
        class="mt-1 block pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
    >
        <option v-if="nullOption" value="">
            <template v-if="nullOptionText">
                {{ nullOptionText }}
            </template>
            <template v-else>
                {{ $t('messages.select') }}
            </template>
        </option>
        <template v-if="optgroups">
            <optgroup v-for="optgroup in options" :label="optgroup.label" :key="optgroup.label">
                <option v-for="option in optgroup.options" :value="option[propertyValue]" :key="option[propertyValue]">
                    {{ option[propertyName] }}
                </option>
            </optgroup>
        </template>
        <template v-else>
            <option v-for="option in options" :value="option[propertyValue]" :key="option[propertyValue]">
                {{ option[propertyName] }}
            </option>
        </template>
    </select>
</template>

<script>
export default {
    name: 'FormSelect',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            required: true,
        },
        disabled: {
            required: false,
            type: Boolean,
            default: false,
        },
        options: {
            required: true,
            type: Array,
        },
        nullOption: {
            required: false,
            type: Boolean,
            default: true,
        },
        nullOptionText: {
            required: false,
            type: String,
            default: '',
        },
        propertyName: {
            required: false,
            type: String,
            default: 'text',
        },
        propertyValue: {
            required: false,
            type: String,
            default: 'value',
        },
        optgroups: {
            required: false,
            type: Boolean,
            default: false,
        },
    },
};
</script>
